import { defineModule } from '../utils/helpers';

// Globals the Complianz plugin defines, so the snake_case names are not ours.
/* eslint-disable @typescript-eslint/naming-convention */
declare const show_cookie_banner: unknown;
declare const cmplz_set_category_as_body_class: unknown;
/* eslint-enable @typescript-eslint/naming-convention */

export default defineModule(() => {
  // complianz
  if (typeof show_cookie_banner === 'function') show_cookie_banner();
  if (typeof cmplz_set_category_as_body_class === 'function')
    cmplz_set_category_as_body_class();
});
